import { render, staticRenderFns } from "./pages3.vue?vue&type=template&id=5107750c&scoped=true&"
import script from "./pages3.vue?vue&type=script&lang=js&"
export * from "./pages3.vue?vue&type=script&lang=js&"
import style0 from "./pages3.vue?vue&type=style&index=0&id=5107750c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107750c",
  null
  
)

export default component.exports